<template>
    <div class="viewControl chartConfig_viewDP">
        <div class="chartDivConfig numViewConfig">
            <span class="span_til span_tilMax">视角距离</span>
            <el-input v-model.number="config.map.viewControl.distance" @change="getRender" type="number" min="0"></el-input>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til span_tilMax">上下旋转角度</span>
            <el-input v-model="config.map.viewControl.alpha" @change="getRender" type="number"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til span_tilMax">左右旋转角度</span>
            <el-input v-model="config.map.viewControl.beta" @change="getRender" type="number"></el-input>
            <div class="unit">度</div>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.map.viewControl.autoRotate" @change="getRender">是否开启自动旋转</el-checkbox>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">物体自转方向</span>
            <el-select v-model="config.map.viewControl.autoRotateDirection" placeholder="请选择物体自转方向"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in viewDirection"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til span_tilMax">物体自转速度</span>
            <el-input v-model="config.map.viewControl.autoRotateSpeed" @change="getRender" type="number"></el-input>
            <div class="unit">s</div>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'map_config',
        data() {
            return {
                viewDirection : [
                    {value: 'cw', label: '顺时针方向'},
                    {value: 'ccw', label: '逆时针方向'}
                ],
            }
        },
        computed: {
            config() {
                if (this.$store.state.dpType === 0) {
                    return this.$store.state.viewDP.chart.setting.params;
                } else {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
            nowChart() {
                if (this.$store.state.dpType === 0) {
                    return this.$store.state.viewDP.nowChart;
                } else {
                    return this.$store.state.designer.chart;
                }
            }
        },
        methods: {
            // 获取当前选中部门的名称
            getRender() {
                if (this.$store.state.dpType === 0) {
                    this.$store.dispatch('viewDPRender');
                } else if (this.$store.state.dpType === 1) {
                    this.$store.dispatch('screenRender');
                }
            },

        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .viewControl {
        .chartDivConfig{
            .span_til{
                max-width:70px!important;
            }
            .span_tilMax{
                width:32%!important;
                max-width:90px!important;
            }
        }

    }
</style>